<div
  class="row"
  style="padding-left: 15px"
  *ngIf="hasEntitlement('CARDHOLDERACCTS_HISTORY')"
>
  <div
    class="card-nc col-md-5"
    style="background-color: #ffffff; padding-bottom: 6px; margin-right: 30px"
  >
    <div class="row">
      <div class="col-md-5">
        <span class="labelCommon">CHIP ACCOUNT</span><br />
        <select
          class="form-control input-sm"
          [(ngModel)]="selectedChipAccount"
          (change)="fetchTransactionData(null)"
        >
          <option
            *ngFor="let chipAccount of chipAccounts"
            [ngValue]="chipAccount"
          >
            {{ chipAccount.account }}
          </option>
        </select>
      </div>
      <div class="col-md-4" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">ACCOUNT BALANCE</span><br />
        <span class="staticText1"
          ><span class="dollerSymbolColor"><i class="fa fa-usd"></i>&nbsp;</span
          >{{ selectedChipAccount?.currentBalance }}</span
        >
      </div>
      <div class="col-md-3" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">STATUS</span><br />
        <span class="staticText1"
          >{{ selectedChipAccount?.status }} &nbsp;<i
            [ngClass]="selectedChipAccount?.status | processingStatusPipe"
          ></i
        ></span>
      </div>
    </div>
  </div>

  <div
    class="col-md-1"
    style="
      margin-left: -40px;
      margin-right: -6px;
      padding-right: 0px;
      padding-left: 0px;
    "
  >
    &nbsp;
  </div>
  <div
    class="card-nc col-md-6"
    style="background-color: #ffffff; padding-bottom: 6px"
  >
    <div class="row">
      <div class="col-md-5">
        <span class="labelCommon">STRIP ACCOUNT</span><br />
        <span class="staticText1">{{ stripAccount?.account }}</span>
      </div>
      <div class="col-md-4" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">ACCOUNT BALANCE</span><br />
        <span class="staticText1"
          ><span class="dollerSymbolColor"><i class="fa fa-usd"></i>&nbsp;</span
          >{{ stripAccount?.currentBalance }}</span
        >
      </div>
      <div class="col-md-3" style="padding-right: 0px; padding-left: 0px">
        <span class="labelCommon">STATUS</span><br />
        <span class="staticText1"
          >{{ stripAccount?.status }} &nbsp;<i
            [ngClass]="stripAccount?.status | processingStatusPipe"
          ></i
        ></span>
      </div>
    </div>
  </div>
</div>

<div
  class="card card-nc"
  style="background-color: rgba(65, 65, 65, 0.8)"
  *ngIf="hasEntitlement('CARDHOLDERACCTS_HISTORY')"
>
  <div
    class="row"
    style="margin-left: 10px; margin-right: 0px; margin-top: 10px"
  >
    <div class="col-md-3" style="padding-right: 0px">
      <span class="cardHeaderHeading"
        ><i class="fa fa-credit-card"></i> ACCOUNT HISTORY</span
      >
    </div>
    <div class="form-group col-md-4">
      <div class="row">
        <div class="col-md-3 cardHeaderHeading zeroPadding">Start Date</div>
        <div class="col-md-8 input-group datepicker dtpicker-btn">
          <input
            id="startDate"
            [ngModel]="startDate"
            class="form-control"
            (dateSelect)="changeStartDate($event)"
            [maxDate]="endDate"
            (change)="changeStartDate($event)"
            ngbDatepicker
            #d1="ngbDatepicker"
            readonly="readonly"
            (click)="d1.toggle()"
          />
          <div class="input-group-append">
            <button
              class="fa fa-calendar"
              (click)="d1.toggle()"
              type="button"
            ></button>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group col-md-4" style="padding-right: 0px">
      <div class="row">
        <div class="col-md-3 cardHeaderHeading zeroPadding">End Date</div>
        <div class="col-md-8 input-group datepicker dtpicker-btn">
          <input
            id="endDate"
            class="form-control"
            [ngModel]="endDate"
            [minDate]="startDate"
            (dateSelect)="changeEndDate($event)"
            (change)="changeEndDate($event)"
            ngbDatepicker
            #d2="ngbDatepicker"
            readonly="readonly"
            (click)="d2.toggle()"
          />
          <div class="input-group-append">
            <button
              class="fa fa-calendar"
              (click)="d2.toggle()"
              type="button"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" style="margin-left: 10px; margin-right: 10px">
    <div
      class="col-md-6"
      style="
        overflow-y: auto;
        height: 350px;
        background-color: #ffffff;
        padding-left: 0px;
        padding-right: 0px;
      "
      *ngIf="hasEntitlement('CARDHOLDERACCTS_CHIP_PURCHASES')"
    >
      <div
        style="background-color: #3b74b0; padding-bottom: 5px; padding-top: 5px"
      >
        <span class="serviceCenterLogin"> &nbsp; CHIP CARD PURCHASE</span>
      </div>

      <div *ngIf="loading">
        <div class="text-center" style="height: 150px">
          <i class="fa fa-spinner fa-2x fa-pulse"></i>
        </div>
      </div>
      <div class="col-md-3" *ngIf="!loading">
        <span class="labelHeading"> &nbsp;Total Spent</span><br /><span
          class="staticText1"
          >&nbsp; {{ totalAmount | currency }}</span
        >
      </div>
      <div class="col-md-9" *ngIf="!loading">
        <div
          class="row rowBorder"
          style="margin-left: 5px"
          *ngFor="let merchant of cardholderMerchantTransactions"
        >
          <div class="col-md-6">
            {{ merchant.merchantName }}
          </div>
          <div class="col-md-2">{{ merchant.percentage }}%</div>
          <div class="col-md-2">
            {{ merchant.amountPerMerchant | currency }}
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>
    <div
      class="col-md-5"
      style="
        overflow-y: auto;
        height: 350px;
        background-color: #ffffff;
        margin-left: 20px;
        padding-left: 0px;
        padding-right: 0px;
      "
      *ngIf="hasEntitlement('CARDHOLDERACCTS_NOTIFICATIONS')"
    >
      <div
        style="background-color: #3b74b0; padding-bottom: 5px; padding-top: 5px"
      >
        <span class="serviceCenterLogin"> &nbsp; NOTIFICATIONS</span>
      </div>
      <div *ngIf="loading">
        <div class="text-center" style="height: 150px">
          <i class="fa fa-spinner fa-2x fa-pulse"></i>
        </div>
      </div>
      <div id="notifications">
        <div class="alert" *ngIf="!loading && notifications.length === 0">
          There are no account notifications available for the selected period.
        </div>
        <div class="alert" *ngFor="let notification of notifications">
          {{ notification }}
        </div>
      </div>
      <div id="alerts">
        <div class="alert" *ngIf="!loading && alerts.length === 0">
          There are no account alerts available for the selected period.
        </div>
        <div class="alert" *ngFor="let alert of alerts">
          {{ alert }}
        </div>
      </div>
    </div>
  </div>

  <div style="margin: 0 35px 0 10px">
    <div class="row">
      <div class="col-md-12">
        <span class="cardHeaderHeading">Transaction History</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10">
        <span class="cardHeaderHeading">
          Balances current as of
          {{
            cardholderDetails?.identity.currentShip.lastRoundtrip
              | date: "medium"
          }}
          EST</span
        >
      </div>
      <div class="col-md-2">
        <div class="row align-bottom">
          <div class="col-md-6 checkbox-inline">
            <label>
              <input
                [(ngModel)]="stripActive"
                type="checkbox"
                value="Strip"
                [disabled]="stripActive && !chipActive"
                (click)="stripActive = !stripActive; filterTransactions()"
              /><span class="cardHeaderHeading">Strip</span>
            </label>
          </div>
          <div class="col-md-6 checkbox-inline">
            <label>
              <input
                [(ngModel)]="chipActive"
                type="checkbox"
                value="Chip"
                [disabled]="!stripActive && chipActive"
                (click)="chipActive = !chipActive; filterTransactions()"
              /><span class="cardHeaderHeading">Chip</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row" style="margin-left: 10px; margin-right: 10px">
    <div class="table-responsive">
      <table class="table tableBackground tableRow table-bordered table-hover">
        <thead style="background-color: #3b74b0">
          <tr>
            <th>DATE</th>
            <th>POSTED</th>
            <th>TYPE</th>
            <th>DESCRIPTION</th>
            <th>AMOUNT</th>
            <th>BALANCE</th>
            <th></th>
          </tr>
        </thead>
        <tbody style="background-color: #ffffff">
          <tr *ngIf="loading">
            <td class="text-center" colspan="6" style="height: 150px">
              <i class="fa fa-spinner fa-2x fa-pulse"></i>
            </td>
          </tr>
          <tr *ngIf="transactions.length == 0 && !loading">
            <td colspan="7">No account activity found</td>
          </tr>
          <ng-container *ngFor="let transaction of transactions">
            <tr *ngIf="!loading">
              <td class="transactionHistText text-center">
                {{ transaction.tran?.date | date: "mediumDate" }}
              </td>
              <!-- pattern="MM/dd/yyyy" -->
              <td class="transactionHistText text-center">
                {{ transaction.tran?.postDate | date: "mediumDate" }}
              </td>
              <td class="transactionHistText text-center">
                {{ transaction.acctType }}
              </td>
              <td class="transactionHistText text-left">
                {{ transaction.tran?.descr }}
              </td>
              <td
                class="text-center"
                [ngClass]="{
                  'text-success': transaction.tran?.amount >= 0.0,
                  'text-fail': transaction.tran?.amount < 0.0
                }"
              >
                {{ transaction.tran?.amount | currency }}
              </td>
              <td
                class="text-center"
                [ngClass]="{
                  'text-success': transaction.tran?.balance >= 0.0,
                  'text-fail': transaction.tran?.balance < 0.0
                }"
              >
                {{ transaction.tran?.balance | currency }}
              </td>
              <td>
                <a
                  ><i
                    *ngIf="!transaction.expanded"
                    class="fa fa-plus-square"
                    (click)="
                      transaction.expanded = true; showDetails(transaction)
                    "
                  ></i>
                  <i
                    *ngIf="transaction.expanded"
                    class="fa fa-minus-square"
                    (click)="transaction.expanded = false"
                  ></i
                ></a>
              </td>
            </tr>
            <tr *ngIf="transaction.expanded">
              <td colspan="7">
                <div *ngIf="transaction.c2cDetails !== ''">
                  {{ transaction.c2cDetails }}
                </div>
                <div *ngFor="let entry of transaction.tranDetails | keyvalue">
                  <span class="transactionHistText"
                    ><strong>{{ entry.key }}</strong
                    >&nbsp;{{ entry.value }}</span
                  >
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
      <app-pagination
        *ngIf="transactions && transactions.length > itemsPerPage"
        (pageSet)="pageSet($event)"
        [totalItems]="transactions.length"
        [itemsPerPage]="itemsPerPage"
      >
      </app-pagination>
    </div>
  </div>
</div>
<div
  id="legal"
  class="card card-alert"
  document-click="clearActionTips($event)"
>
  <div class="card-heading">
    <span class="icon-NC_warning"></span>
    <span class="label">IMPORTANT NOTES</span>
  </div>
  <div class="card-body">
    <p>
      In case of errors or questions about your transactions please see the
      <a href="../assets/navy_cash_error_resolution_notice.pdf" target="_blank"
        >Navy Cash Card Error Resolution Notice</a
      >.
    </p>
  </div>
</div>
